import React from 'react'

interface AudienceDisplayProps {
    /** Whether the notification targets all subscribers */
    allSubscribers?: boolean
    /** Targeted segments */
    segments?: Array<{ id: string | number; name: string }>
    /** Label for the Descriptions.Item (caller handles this) */
}

/** Renders audience segments as a comma-separated list, or "All Subscribers" if applicable. */
export const AudienceDisplay: React.FC<AudienceDisplayProps> = ({ allSubscribers, segments = [] }) => {
    if (!allSubscribers && segments.length === 0) return null

    if (allSubscribers) {
        return <span>All Subscribers</span>
    }

    return <span>{segments.map((s) => s.name).join(', ')}</span>
}
